<div class="p-grid p-formgrid">
  <div class="p-field p-col-12">
    {{texto}}
  </div>
</div>